import React, { useState, useEffect, useMemo } from 'react'
import { Alert, Checkbox, Collapse, Paper, Stack, Typography, TextField, InputAdornment, IconButton, Grid } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';

import { RemoveOutlined, AddOutlined } from '@mui/icons-material'
import { QuoteDetails } from './QuotesSharedComponents'


export default function WaybillResume({ sender, recipient, packet, shipment, setShipment, validatedWaybill, setValidatedWaybill, finalpriceState, quantity, setQuantity , multipleState}) {
  const userPermissions = JSON.parse(sessionStorage.getItem('permissions'))
  const [finalPrice, setFinalPrice] = finalpriceState;
  const [waybillResumeFinalPrice, setWaybillResumeFinalPrice] = useState(String(finalPrice.toFixed(2)))
  const [subtotal, setSubtotal] = useState(0);
  const [multiple, setMultipleState] = multipleState;

  const waybill = useMemo(() => ({
    tipo_servicio_id: shipment.servicio_id,
    tipo_servicio_nombre: shipment.servicio_nombre,
    kg: packet.peso,
    alto: packet.alto,
    ancho: packet.ancho,
    largo: packet.largo,
    origenEmpresa: sender.empresa,
    origenPersona: `${sender.nombre} ${sender.apellidoPaterno} ${sender.apellidoMaterno ?? ''}`.trim(),
    origenCalle: sender.calle,
    origenNumExt: sender.numeroExterior,
    origenNumInt: sender.numeroInterior,
    origenColonia: sender.colonia,
    origenMunicipio: sender.municipio,
    origenEstado: sender.estado,
    origenPais: sender.pais,
    origenCP: sender.codigoPostal,
    origenTelefono1: sender.telefono1,
    origenTelefono2: sender.telefono2,
    origenRef: sender.referencia,
    destinoEmpresa: recipient.empresa,
    destinoPersona: `${recipient.nombre} ${recipient.apellidoPaterno} ${recipient.apellidoMaterno ?? ''}`.trim(),
    destinoCalle: recipient.calle,
    destinoNumExt: recipient.numeroExterior,
    destinoNumInt: recipient.numeroInterior,
    destinoColonia: recipient.colonia,
    destinoMunicipio: recipient.municipio,
    destinoEstado: recipient.estado,
    destinoPais: recipient.pais,
    destinoCP: recipient.codigoPostal,
    destinoTelefono1: recipient.telefono1,
    destinoTelefono2: recipient.telefono2,
    destinoRef: recipient.referencia,
    costoDeEnvio: Number(shipment.costo),
    valorDeMercancia: Number(shipment.mercancia),
    montoACobrar: shipment.quienPaga === 1 ? (Number(shipment.costo) + Number(shipment.mercancia)).toFixed(2) : 0,
    pago_en_destino: shipment.quienPaga,
    origenDestino: shipment.quienPaga === 1 ? 'Destino' : 'Origen',
    eta: shipment.eta,
    generadoPorUsuario: 1,
    esSobre: packet.esSobre,

    precio_kg_adicional: shipment?.precio_kg_adicional,
    kg_amparados: shipment?.precio_kg_adicional,
    kg_cotizados: shipment?.kg_cotizados,
    sobrepeso: shipment?.sobrepeso

  }), [shipment, packet, sender, recipient])
  const maxItems = 20

  const catchFinalPrice = e => {
    const value = e.target.value.replace(/[^0-9.]/g, "").replace(/^(\d*\.?)|(\d*)\.?/g,"$1$2")

    setWaybillResumeFinalPrice(value)
    setFinalPrice(value !== "" ? Number(value) : 0)
  }
  useEffect(() => {
    setSubtotal(finalPrice * quantity)
  },[])
  useEffect(() => {
    setSubtotal(finalPrice * quantity)
    if (quantity<=1) {setMultipleState([])}
  },[finalPrice, quantity])

  return (
    <>
      <Stack spacing={2}>
        <Paper variant='outlined'>
          <QuoteDetails waybill={waybill} />
        </Paper>

        <Grid
          // direction="row"
          // alignItems="center"
          // justifyContent="space-between"
          container
          columnSpacing={1}
          rowSpacing={1}
        >
          {/* { 
            ['Admin', 'PDV'].includes(userPermissions['role']) && (
              <FormControl
                size='small'
                sx={{ width: 175 }}
              >
                <InputLabel id='shipment-selector-label'>¿Quién realiza el pago?</InputLabel>
                <Select
                  labelId='shipment-selector-label'
                  id='shipment-selector'
                  value={shipment.quienPaga}
                  label='¿Es un sobre tu paquete?'
                  onChange={event => setShipment({ ...shipment, quienPaga: event.target.value })}
                >
                  <MenuItem value={0}>Origen</MenuItem>
                  <MenuItem value={1}>Destino</MenuItem>
                </Select>
              </FormControl>
            )
          } */}
          <Alert
            sx={{ mt: 1, mb: 1 }}
            severity='warning'
          >
            El campo de cantidad de guias no esta disponible aun para todos los carriers, porfavor validalo con tu proveedor.
        </Alert>

          <Grid
            item
            xs={12}
            sm={12}
            md={3.5}
            lg={3.5}
            display='flex'
            alignItems='center'
            justifyContent='center'
          >
            <TextField 
              label='Cantidad'
              variant='outlined'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <IconButton
                      onClick={() => setQuantity(quantity > 1 ? quantity - 1 : quantity)}
                    >
                      <RemoveOutlined sx={{ fontSize: '12px' }} />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      onClick={() => setQuantity(quantity < maxItems ? quantity + 1 : quantity)}
                    >
                      <AddOutlined sx={{ fontSize: '12px' }} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              onChange={event => setQuantity(/^\d{0,3}$/.test(event.target.value) && Number(event.target.value) < maxItems+1  ? Number(event.target.value) : Number(quantity))}
              value={quantity}
              size='small'
            />
          </Grid>

          {
            !['SubCliente'].includes(userPermissions['role']) && <>
              <Grid
                item
                xs={12}
                sm={12}
                md={3.5}
                lg={3.5}
                display='flex'
                alignItems='center'
                justifyContent='center'
              >
                <TextField
                  disabled={['Admin', 'PDV', 'Supervisor'].includes(userPermissions['role']) ? false : true}
                  label='Precio por envio'
                  placeholder='0.00'
                  value={waybillResumeFinalPrice}
                  onChange={catchFinalPrice}
                  sx={{width: 175}}
                  size="small"
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={5}
                lg={5}
                display='flex'
                alignItems='center'
                justifyContent='center'
                gap='4px'
              >
                <Typography
                  fontSize='14px'
                  fontWeight='700'
                >
                  Subtotal: <span style={{ fontWeight: 400 }}>{subtotal.toFixed(2)}</span>
                </Typography>
              </Grid>
            </>
          }
        </Grid>
        {quantity > 1 && (
          <WeightsAndMeasuresTable 
                        quantityState={[quantity, setQuantity]} 
                        waybill={waybill} 
                        price={waybillResumeFinalPrice}
                        subtotalState={[subtotal, setSubtotal]} 
                        multipleState={multipleState}
                        />
        )}

        <Stack
          direction='row'
          alignItems='start'
        >
          <Checkbox
            checked={validatedWaybill}
            onChange={event => setValidatedWaybill(event.target.checked)}
          />
          <Typography>He leído y confirmo que los datos de la guía a generar son los correctos, conociendo qué, en caso de error, no será posible realizar modificaciones</Typography>
        </Stack>
      </Stack>

      <Collapse in={!validatedWaybill}>
        <Alert
          sx={{ mt: 2 }}
          severity='warning'
        >
          Antes de continuar, verifica que la información mostrada sea la correcta, ya que no se podrán realizar modificaciones una vez efectuado el pago de la guía
        </Alert>
      </Collapse>

      <Collapse in={shipment.quienPaga === 1}>
        <Alert
          sx={{ mt: 2 }}
          severity='info'
        >
          Debido a que el envío se cobrará en el destino, congelaremos el costo del envío. Una vez el destino haya pagado, reembolsaremos la cantidad en forma de saldo a favor
        </Alert>
      </Collapse>

      <Collapse in={shipment.quienPaga === 1 && Number(shipment.costo) + Number(shipment.mercancia) > 3000}>
        <Alert
          sx={{ mt: 2 }}
          severity='error'
        >
          En envíos donde el destino es quién paga, el monto a cobrar no puede superar los $3000
        </Alert>
      </Collapse>

      <Collapse in={finalPrice < shipment.costo}>
        <Alert
          sx={{ mt: 2 }}
          severity="error"
        >
          El precio final no debe ser menor al costo de envio
        </Alert>
      </Collapse>
    </>
  )
}

const WeightsAndMeasuresTable = ({ quantityState, waybill, price, multipleState, subtotalState }) => {
  const [quantity, setQuantity] = quantityState
  const [multiple, setMultiple] = multipleState
  const [subtotal, setSubtotal] = subtotalState
  const [rows, setRows] = useState([{
    id: 1,
    weight: waybill.kg, // Peso inicial
    length: waybill.alto, // Longitud inicial
    width: waybill.largo,  // Ancho inicial
    height: waybill.ancho, // Altura inicial
    price: price // Precio de envio inicial
  }]);
  const inicialWeight = Math.max(waybill.kg_cotizados,waybill.kg_amparados);

  // Inicializar las filas basadas en la cantidad
  useEffect(() => {
    // Reemplazar todas las filas en función de `quantity`
    const updatedRows = quantity <= 1 ? [] : Array.from({ length: quantity }, (_, index) => ({
      id: index + 1,
      weight: waybill.kg || 0, // Peso inicial del paquete
      length: waybill.alto || 0, // Longitud inicial del paquete
      width: waybill.largo || 0, // Ancho inicial del paquete
      height: waybill.ancho || 0, // Altura inicial del paquete
      price: price,
      is_envelope: waybill.esSobre || false,
    }));

    setMultiple(updatedRows);
    setRows(updatedRows);
  }, [quantity, waybill, price]);

  useEffect(() => {
    const total = rows.reduce((acc, row) => acc + (Number(row.price) || 0), 0);
    setSubtotal(total);
  }, [rows, setSubtotal]);

  // Manejar la actualización de las filas
  const handleProcessRowUpdate = (params) => {
    
    const pricePerKg = Number(waybill?.precio_kg_adicional || 0);
    const basePrice = Number(price);

    const updatedRows = rows.map((row) => {
      if (row.id === params.id) {
        const updatedRow = {
          ...row,
          [params.field]:
            params.field === 'price' // Validar solo si el campo es `price`
              ? Math.max(Number(params.value), basePrice) // Asegurar que `price` no sea menor que el mínimo
              : params.value,
        }
        

        if (['weight', 'length', 'width', 'height'].includes(params.field)) {
          const w = Number(updatedRow.weight) || 0;
          const l = Number(updatedRow.length) || 0;
          const h = Number(updatedRow.height) || 0;
          const wd = Number(updatedRow.width) || 0;
          const volumetric = (l * h * wd) / 5000;
          const maxWeight = Math.max(volumetric, w);

          if (maxWeight > inicialWeight) {
            updatedRow.price = basePrice + ((maxWeight - inicialWeight) * pricePerKg);
          } else {
            updatedRow.price = basePrice;
          }
        }

        return updatedRow;
      }
      return row;
    });
    setMultiple(updatedRows)
    setRows(updatedRows);
  };

  // Definir las columnas de la tabla
  let columns = [
    { field: 'id', headerName: 'ID', width: 50, headerAlign: 'center', align: 'center' },
    { field: 'weight', headerName: 'Peso (kg)', width: 80, editable: true, type: 'number', headerAlign: 'center', align: 'center', renderHeader: (params) => <Typography align="center" style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>Peso (kg)</Typography> },
  ];
  
  // Agregar columnas adicionales (`length`, `width`, `height`) justo después de `weight` si no es sobre
  if (!rows.some(row => row.is_envelope)) {
    columns = [
      ...columns,
      { field: 'length', headerName: 'Largo (cm)', width: 80, editable: true, type: 'number', headerAlign: 'center', align: 'center', renderHeader: (params) => <Typography align="center" style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>Largo (cm)</Typography> },
      { field: 'width', headerName: 'Ancho (cm)', width: 80, editable: true, type: 'number', headerAlign: 'center', align: 'center', renderHeader: (params) => <Typography align="center" style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>Ancho (cm)</Typography> },
      { field: 'height', headerName: 'Altura (cm)', width: 80, editable: true, type: 'number', headerAlign: 'center', align: 'center', renderHeader: (params) => <Typography align="center" style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>Altura (cm)</Typography> },
    ];
  }
  
  // Agregar las columnas restantes
  columns = [
    ...columns,
    { field: 'price', headerName: 'Precio de envio', width: 100, editable: true, type: 'number', headerAlign: 'center', align: 'center', renderHeader: (params) => <Typography align="center" style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>Precio de envio</Typography> },
    { field: 'is_envelope', headerName: 'Tipo', width: 90, editable: false, type: 'boolean', headerAlign: 'center', align: 'center', renderHeader: (params) => <Typography align="center" style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>Tipo</Typography>, renderCell: (params) => (params.row.is_envelope ? "Sobre" : "Paquete") },
  ];

  return (
    <Paper sx={{ height: 400, width: '100%', spacing: 2, mb:10}}>
      <Alert severity="info">
        <Typography>
          Ingresa los pesos y medidas para cada cantidad
        </Typography>
      </Alert>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSizeOptions={[5, 10]}
        sx={{ border: 0 }}
        editMode="cell"
        onCellEditCommit={handleProcessRowUpdate}
      />
    </Paper>
  );
};
